<template>
    <BreadCrumb PageTitle="Modifier une validation task" />
    <EditValidationTask />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditValidationTask from "@/components/ValidationTasks/EditValidationTask.vue";

export default defineComponent({
    name: "EditValidationTaskPage",
    components: {
        BreadCrumb,
        EditValidationTask,
    },
});
</script>